$(document).ready(function () {
	var API = $('#main-menu').data('mmenu')

	$('.search-toggle').click(function (event) {
		event.preventDefault()
		$('.search-field-container').slideToggle()
		API.close()
	})
	$('.close-search').click(function (event) {
		event.preventDefault()
		$('.search-field-container').slideToggle()
	})

	if ($('.search-field-container').is(':visible')) {
		$(document).click(function () {
			$('.search-field-container').hide()
		})
	}
})
